import request from '@/utils/request'

import config from '@/config/index'
import enumObject from "@/utils/enum";
const GateWay = enumObject.providerConfig[config.projectName].gateway;
// 调取非税发票
export function GCInvoicing (data) {
    return request({
        url: GateWay + '/invoicing/api/GCInvoicing',
        method: 'post',
        data
    })
}
// 调取百旺抬头联想
export function getInvoiceTitleInfoByBW (data) {
    return request({
        url: GateWay + '/bwjfInvoiceHandle/fuzzyQueryCompanyName',
        method: 'post',
        data
    })
}
// 调取票通
export function getInvoiceTitleInfo (data) {
    return request({
        url: GateWay + '/pt/getInvoiceTitleInfo',
        method: 'post',
        data
    })
}
// 票通开票
export function setBTInvoiceInfomationBymiddl (data) {
    return request({
        url: GateWay + '/pt/invoice',
        method: 'post',
        data
    })
}
// 票通重新开票
export function setBTResendEmail (data) {
    return request({
        url: GateWay + '/pt/ResendEmail',
        method: 'post',
        data
    })
}
// 添加开票信息
export function addBillingInformation (data) {
    return request({
        url: GateWay + '/mainPlatform/addBillingInformation',
        method: 'post',
        data
    })
}
// 修改开票信息
export function ChangeInvoiceInfomation (data) {
    return request({
        url: GateWay + '/mainPlatform/updateBillingInformation',
        method: 'post',
        data
    })
}
// 查询开票信息
export function getBillingInformation (data) {
    return request({
        url: GateWay + '/mainPlatform/getBillingInformation',
        method: 'post',
        data
    })
}
// 获取开票token
export function getInvoiceToken (data) {
    return request({
        url: GateWay + '/jsbwjf/open_access/getToken',
        method: 'post',
        data
    })
}
// 提交百旺发票（中间件）
export function setInvoiceInfomationBymiddl (data) {
    return request({
        url: GateWay + '/bwjfInvoiceHandle/InvoicingV2',
        method: 'post',
        data
    })
}

// 提交发票信息(hx)
export function setInvoiceInfomationHX (data) {
    return request({
        url: GateWay + '/hxfp/InvoiceV3',
        method: 'post',
        data
    })
}
//  发邮箱（hx）
export function getPDFUEL (data) {
    return request({
        url: GateWay + '/hxfp/queryInvoiceOrder',
        method: 'post',
        data
    })
}
//  重发邮箱（hx）
export function againSendEmailHX (data) {
    return request({
        url: GateWay + '/hxfp/againSendEmail',
        method: 'post',
        data
    })
}
// 聚合重新开票
export function againSendEmail (data) {
    return request({
        url: GateWay + '/invoicing/api/againSendEmail',
        method: 'post',
        data
    })
}
// // 查询行程
// export function getStrokeInfomation (data) {
//     return request({
//         url: GateWay +'jsbwjf/ticketOpen/execProcedure',
//         method: 'post',
//         data
//     })
// }
// 查询开票方 
export function SetIssuer (data) {
    return request({
        url: GateWay + '/invoicing/api/getSellerInformation',
        method: 'post',
        data
    })
}
// 查询开票方 新
export function getSellerInformationByParkId (data) {
    return request({
        url: GateWay + '/invoicing/api/getGCSellerInformation',
        method: 'post',
        data
    })
}
// 根据chargeId查订单
export function getOrderById (data) {
    return request({
        url: GateWay + '/mainPlatform/getById',
        method: 'post',
        data
    })
}



// 聚合发票
export function invoicing (data) {
    return request({
        url: GateWay + '/invoicing/api/InvoicingV4',
        method: 'post',
        data
    })
}
// 聚合重新开票
export function setResendEmail (data) {
    return request({
        url: GateWay + '/invoicing/api/againSendEmail',
        method: 'post',
        data
    })
}
//查询开票历史
export function getBillingHistory (data) {
    return request({
        url: GateWay + '/handleWx/getBillingHistory',
        method: 'post',
        data
    })
}





